// 自動生成ファイル。手で編集しないこと。
// `npm run build-scenes` で src/missions/index.ts から再生成される。
//
// プレビューのシーンキー（{slug}_{num}）から、変換済みシーン JSON のテンプレ名への写像。
// ローダ（sceneLoader.ts）がこの写像でシーン JSON の URL（/scenes/{テンプレ名}.json）を解決する。

export const SCENE_MANIFEST: Readonly<Partial<Record<string, string>>> = {
  rb1_1: 'RJF01',
  rb1_10: 'RJF10',
  rb1_11: 'RJF11',
  rb1_12: 'RJF12',
  rb1_2: 'RJF02',
  rb1_3: 'RJF03',
  rb1_4: 'RJF04',
  rb1_5: 'RJF05',
  rb1_6: 'RJF06',
  rb1_7: 'RJF07',
  rb1_8: 'RJF08',
  rb1_9: 'RJF09',
  rb2_1: 'RJS01',
  rb2_10: 'RJS10',
  rb2_11: 'RJS11',
  rb2_12: 'RJS12',
  rb2_2: 'RJS02',
  rb2_3: 'RJS03',
  rb2_4: 'RJS04',
  rb2_5: 'RJS05',
  rb2_6: 'RJS06',
  rb2_7: 'RJS07',
  rb2_8: 'RJS08',
  rb2_9: 'RJS09',
  rj1_10: 'RJF10',
  rj1_11: 'RJF11',
  rj1_12: 'RJF12',
  rj1_2: 'RJF02',
  rj1_3: 'RJF03',
  rj1_4: 'RJF04',
  rj1_5: 'RJF05',
  rj1_6: 'RJF06',
  rj1_7: 'RJF07',
  rj1_8: 'RJF08',
  rj1_9: 'RJF09',
  rj1_trial_1: 'RJF01',
  rj2_1: 'RJS01',
  rj2_10: 'RJS10',
  rj2_11: 'RJS11',
  rj2_12: 'RJS12',
  rj2_2: 'RJS02',
  rj2_3: 'RJS03',
  rj2_4: 'RJS04',
  rj2_5: 'RJS05',
  rj2_6: 'RJS06',
  rj2_7: 'RJS07',
  rj2_8: 'RJS08',
  rj2_9: 'RJS09',
}
